import React from 'react';

/**
 * This is displayed to the user where there has been an error
 */
const Error = () => (
  <p>Sorry we couldn't find your location, please try again.</p>
);

export default Error;
